import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { FeatureFlags } from '../feature-flags/feature-flags';
import type { PackingSlipTemplate } from '../pages/settings/templates-packing-slips/types';
import Global from '../store/global-selectors';

export const getVisiblePackingSlips = createSelector(
  (state: object) => Global.selectSellerPackingSlips(state) as PackingSlipTemplate[],
  (state: object) => new FeatureFlags({ state }).enableNewHtmlEditorForPackingSlips,
  (packingSlips: PackingSlipTemplate[], isEnabled: boolean): PackingSlipTemplate[] =>
    isEnabled ? packingSlips : packingSlips.filter((slip) => !slip.htmlTemplateKey),
);

export const useVisiblePackingSlips = (): PackingSlipTemplate[] => {
  return useSelector(getVisiblePackingSlips);
};
